import { render, staticRenderFns } from "./RunnitTemplatesDashboard.vue?vue&type=template&id=5a53805d"
import script from "./RunnitTemplatesDashboard.vue?vue&type=script&lang=ts"
export * from "./RunnitTemplatesDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports